/**
 * QuickSight Configuration
 * Environment variables loaded from:
 * - localhost: .env.development
 * - AWS Amplify: Console environment variables
 */

export const quicksightConfig = {
  dashboards: {
    digital: process.env.REACT_APP_QUICKSIGHT_DASHBOARD_DIGITAL || '',
    offer: process.env.REACT_APP_QUICKSIGHT_DASHBOARD_OFFER || '',
    store: process.env.REACT_APP_QUICKSIGHT_DASHBOARD_STORE || '',
    dwd: process.env.REACT_APP_QUICKSIGHT_DASHBOARD_DWD || '',
    dwdOffer: process.env.REACT_APP_QUICKSIGHT_DASHBOARD_DWD_OFFER || ''
  },
  defaultDashboardId: process.env.REACT_APP_QUICKSIGHT_DEFAULT_DASHBOARD || '',
  embeddingOptions: {
    height: '100%',
    undoRedo: false,
    reset: true,
    toolbarOptions: {
      export: true,
      undoRedo: false,
      reset: true
    }
  }
};

export default quicksightConfig;